
// import React from "react";

// const ESGTable = ({ company }) => {
//   const { stats } = company;

//   const renderTable = (data, options = {}) => {
//     const { withIndex = false, showNote = false } = options;

//     if (!data || !Array.isArray(data.tableData)) {
//       return (
//         <p style={{ color: "#999", fontStyle: "italic", marginBottom: "1rem" }}>
//           No data available
//         </p>
//       );
//     }

//     // Years detect
//     const years = Object.keys(data.tableData[0]).filter(
//       (k) =>
//         k !== "indicator" &&
//         k !== "note" &&
//         k !== "isGroup" &&
//         k !== "isSub"
//     );

//     let visibleIndex = 1;

//     return (
//       <div style={{ overflowX: "auto", marginBottom: 30 }}>
//         <table
//           style={{
//             width: "100%",
//             borderCollapse: "collapse",
//             minWidth: "600px",
//             fontSize: "14px",
//             backgroundColor: "#fff",
//             boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
//             borderRadius: "8px",
//           }}
//         >
//           <thead style={{ backgroundColor: "#f8f9fa" }}>
//             <tr>
//               {withIndex && (
//                 <th
//                   style={{
//                     padding: "10px",
//                     borderBottom: "2px solid #dee2e6",
//                     textAlign: "center",
//                     fontWeight: "600",
//                     color: "#333",
//                     width: "50px",
//                   }}
//                 >
//                   #
//                 </th>
//               )}

//               <th
//                 style={{
//                   padding: "10px",
//                   borderBottom: "2px solid #dee2e6",
//                   textAlign: "left",
//                   fontWeight: "600",
//                   color: "#333",
//                 }}
//               >
//                 Indicator
//               </th>

//               {years.map((year) => (
//                 <th
//                   key={year}
//                   style={{
//                     padding: "10px",
//                     borderBottom: "2px solid #dee2e6",
//                     textAlign: "center",
//                     fontWeight: "600",
//                     color: "#333",
//                     width: "90px",
//                   }}
//                 >
//                   {year}
//                 </th>
//               ))}
//             </tr>
//           </thead>

//           <tbody>
//             {data.tableData.map((row, index) => {
//               // ✅ GROUP ROW (NO NUMBER)
//               if (row.isGroup) {
//                 return (
//                   <tr key={index}>
//                     {withIndex && <td></td>}
//                     <td
//                       colSpan={years.length + (withIndex ? 1 : 0)}
//                       style={{
//                         padding: "10px",
//                         backgroundColor: "#e7f1ff",
//                         fontWeight: "700",
//                         color: "#0a58ca",
//                         borderBottom: "1px solid #ccc",
//                       }}
//                     >
//                       {row.indicator}
//                     </td>
//                   </tr>
//                 );
//               }

//               // ✅ NORMAL + SUB (BOTH COUNT)
//               const currentIndex = visibleIndex++;

//               return (
//                 <tr
//                   key={index}
//                   style={{
//                     backgroundColor:
//                       index % 2 === 0 ? "#ffffff" : "#f7f9fc",
//                   }}
//                 >
//                   {withIndex && (
//                     <td
//                       style={{
//                         padding: "8px 10px",
//                         borderBottom: "1px solid #eaeaea",
//                         textAlign: "center",
//                         color: "#444",
//                         fontWeight: "500",
//                       }}
//                     >
//                       {currentIndex}
//                     </td>
//                   )}

//                   <td
//                     style={{
//                       padding: "8px 10px",
//                       paddingLeft: row.isSub ? "30px" : "10px",
//                       borderBottom: "1px solid #eaeaea",
//                       textAlign: "left",
//                       fontWeight: row.isSub ? "400" : "500",
//                       color: "#444",
//                     }}
//                   >
//                     <div>{row.indicator}</div>

//                     {showNote && row.note && (
//                       <div
//                         style={{
//                           marginTop: 4,
//                           fontSize: "12px",
//                           color: "#777",
//                           lineHeight: 1.4,
//                         }}
//                       >
//                         {row.note}
//                       </div>
//                     )}
//                   </td>

//                   {years.map((year) => (
//                     <td
//                       key={year}
//                       style={{
//                         padding: "8px 10px",
//                         borderBottom: "1px solid #eaeaea",
//                         textAlign: "center",
//                         color: "#222",
//                       }}
//                     >
//                       {row[year] !== undefined && row[year] !== null
//                         ? row[year].toLocaleString?.() || row[year]
//                         : "-"}
//                     </td>
//                   ))}
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//     );
//   };

//   return (
//     <div style={{ marginTop: 24, fontFamily: "Inter, sans-serif" }}>
//       <h2 style={headingStyle}>
//         Section 1: Reporting on Anti-Corruption Programmes
//       </h2>
//       {renderTable(stats.antiCorruption, { withIndex: true })}

//       <h2 style={headingStyle}>
//         Section 2: Organizational Transparency
//       </h2>
//       {renderTable(stats.organizationalTransparency, {
//         withIndex: true,
//         showNote: true,
//       })}

//       <h2 style={headingStyle}>
//         Section 3: Domestic Financial Reporting
//       </h2>
//       {renderTable(stats.domesticFinancialReporting, { withIndex: true })}

//       <h2 style={headingStyle}>
//         Section 4: Reporting on Gender and Non-Discrimination Policies
//       </h2>
//       {renderTable(stats.genderAndNonDiscrimination, { withIndex: true })}

//       <h2 style={headingStyle}>
//         Section 5: Reporting on Procurement Related to Government Contracts/Tenders
//       </h2>
//       {renderTable(stats.procurementReporting, { withIndex: true })}

//       <h2 style={headingStyle}>
//         Section 6: Human Rights and Corporate Responsibility
//       </h2>
//       {renderTable(stats.humanRightsAndResponsibility, { withIndex: true })}
//     </div>
//   );
// };

// const headingStyle = {
//   backgroundColor: "#3F86E8",
//   color: "#fff",
//   padding: "8px",
//   marginBottom: 10,
// };

// export default ESGTable;


import React from "react";

const ESGTable = ({ company }) => {
  const { stats } = company;

  // Global index for all sections
  let globalIndex = 1;

  const renderTable = (data, options = {}) => {
    const { showNote = false, averageScore = null } = options;

    if (!data || !Array.isArray(data.tableData)) {
      return (
        <p style={{ color: "#999", fontStyle: "italic", marginBottom: "1rem" }}>
          No data available
        </p>
      );
    }

    const years = Object.keys(data.tableData[0]).filter(
      (k) => k !== "indicator" && k !== "note" && k !== "isGroup" && k !== "isSub"
    );

    return (
      <div style={{ overflowX: "auto", marginBottom: 30 }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "600px",
            fontSize: "14px",
            backgroundColor: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            borderRadius: "8px",
          }}
        >
          <thead style={{ backgroundColor: "#f8f9fa" }}>
            <tr>
              <th
                style={{
                  padding: "10px",
                  borderBottom: "2px solid #dee2e6",
                  textAlign: "center",
                  fontWeight: "600",
                  color: "#333",
                  width: "50px",
                }}
              >
                #
              </th>

              <th
                style={{
                  padding: "10px",
                  borderBottom: "2px solid #dee2e6",
                  textAlign: "left",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Indicator
              </th>

              {years.map((year) => (
                <th
                  key={year}
                  style={{
                    padding: "10px",
                    borderBottom: "2px solid #dee2e6",
                    textAlign: "center",
                    fontWeight: "600",
                    color: "#333",
                    width: "90px",
                  }}
                >
                  {year}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.tableData.map((row, index) => {
              if (row.isGroup) {
                return (
                  <tr key={index}>
                    <td></td>
                    <td
                      colSpan={years.length + 1}
                      style={{
                        padding: "10px",
                        backgroundColor: "#e7f1ff",
                        fontWeight: "700",
                        color: "black",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {row.indicator}
                    </td>
                  </tr>
                );
              }

              const currentIndex = globalIndex++;

              return (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f7f9fc",
                  }}
                >
                  <td
                    style={{
                      padding: "8px 10px",
                      borderBottom: "1px solid #eaeaea",
                      textAlign: "center",
                      color: "#444",
                      fontWeight: "500",
                    }}
                  >
                    {currentIndex}
                  </td>

                  <td
                    style={{
                      padding: "8px 10px",
                      paddingLeft: row.isSub ? "30px" : "10px",
                      borderBottom: "1px solid #eaeaea",
                      textAlign: "left",
                      fontWeight: row.isSub ? "400" : "500",
                      color: "#444",
                    }}
                  >
                    <div>{row.indicator}</div>
                    {showNote && row.note && (
                      <div
                        style={{
                          marginTop: 4,
                          fontSize: "12px",
                          color: "#777",
                          lineHeight: 1.4,
                        }}
                      >
                        {row.note}
                      </div>
                    )}
                  </td>

                  {years.map((year) => (
                    <td
                      key={year}
                      style={{
                        padding: "8px 10px",
                        borderBottom: "1px solid #eaeaea",
                        textAlign: "center",
                        color: "#222",
                      }}
                    >
                      {row[year] !== undefined && row[year] !== null
                        ? row[year].toLocaleString?.() || row[year]
                        : "-"}
                    </td>
                  ))}
                </tr>
              );
            })}

            {/* Average Score Row */}
            {averageScore !== null && (
              <tr>
                <td></td>
                <td
                  style={{
                    padding: "8px 10px",
                    fontWeight: "700",
                    borderTop: "2px solid #dee2e6",
                    backgroundColor: "#f0f4ff",
                  }}
                >
                  Total Average Score for this Section
                </td>
                <td
                  colSpan={years.length}
                  style={{
                    padding: "8px 40px",
                    fontWeight: "700",
                    borderTop: "2px solid #dee2e6",
                    textAlign: "left",
                    backgroundColor: "#f0f4ff",
                  }}
                >
                  {averageScore}%
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div style={{ marginTop: 24, fontFamily: "Inter, sans-serif" }}>
      <h2 style={headingStyle}>
        Section 1: Reporting on Anti-Corruption Programmes
      </h2>
      {renderTable(stats.antiCorruption, {
        showNote: false,
        averageScore: company.AntiCorruptionProgrammes,
      })}

      <h2 style={headingStyle}>Section 2: Organizational Transparency</h2>
      {renderTable(stats.organizationalTransparency, {
        showNote: true,
        averageScore: company.OrganisationalTransparency,
      })}

      <h2 style={headingStyle}>Section 3: Domestic Financial Reporting</h2>
      {renderTable(stats.domesticFinancialReporting, {
        showNote: false,
        averageScore: company.DomesticFinancialReporting,
      })}

      <h2 style={headingStyle}>
        Section 4: Reporting on Gender and Non-Discrimination Policies
      </h2>
      {renderTable(stats.genderAndNonDiscrimination, {
        showNote: false,
        averageScore: company.GenderAndNonDiscriminationPolicies,
      })}

      <h2 style={headingStyle}>
        Section 5: Reporting on Procurement Related to Government Contracts/Tenders
      </h2>
      {renderTable(stats.procurementReporting, {
        showNote: false,
        averageScore: null, // No score provided
      })}

      <h2 style={headingStyle}>
        Section 6: Human Rights and Corporate Responsibility
      </h2>
      {renderTable(stats.humanRightsAndResponsibility, {
        showNote: false,
        averageScore: company.HumanRightsAndCorporateResponsibility,
      })}
    </div>
  );
};

const headingStyle = {
  backgroundColor: "#3F86E8",
  color: "#fff",
  padding: "8px",
  marginBottom: 10,
};

export default ESGTable;